package de.emgress.baskets.core.styles

import kotlinx.browser.window
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*
import styles.EColors


object Styles {

    val cssVariables = CSSVariables()
    val cssClasses = CSSClasses()
    val cssConstants = CSSConstants()

    class CSSConstants {
        val breakPointMobile = 768
    }

    class CSSVariables {
        val bodyBackgroundColor by variable<CSSColorValue>()
        val defaultTextColor by variable<CSSColorValue>()
        val prominentTextColor by variable<CSSColorValue>()
    }

    class CSSClasses: StyleSheet() {

        private val queriesString = window.location.search
        private val darkMode = queriesString.contains("darkmode=true")

        init {
            "body" style {
                if (darkMode) {
                    cssVariables.bodyBackgroundColor(Color(EColors.BASKETS_WEBSITE_BLUE_DARK.value))
                    cssVariables.defaultTextColor(Color.white)
                } else {
                    cssVariables.bodyBackgroundColor(Color.white)
                    cssVariables.defaultTextColor(Color.black)
                }
                cssVariables.prominentTextColor(Color(EColors.BASKETS_WEBSITE_ORANGE_HEADLINE.value))

                margin(0.px)
                backgroundColor(cssVariables.bodyBackgroundColor.value())
                color(cssVariables.defaultTextColor.value())

                fontSize(1.em)
            }
            "a" style {
                textDecoration("none")
                color(cssVariables.defaultTextColor.value())
            }
        }

        val bold by style {
            fontWeight("bold")
        }

        val orangeFont by style {
            color(cssVariables.prominentTextColor.value())
        }

        val passionOneFont by style {
            fontFamily("Passion One Bold")
        }

        val barlowFont by style {
            fontFamily("Barlow Regular")
        }

        val paragraph by style {
            margin(0.px)
            textAlign("center")
        }

        val largerParagraph by style {
            marginBottom(8.px)
            marginTop(8.px)
            fontSize(2.em)
        }

        val largeParagraph by style {
            marginTop(8.px)
            marginBottom(8.px)
            fontSize(3.em)
        }

        val horizontalDynamicMarginSmall by style {
            marginLeft(2.5.vw)
            marginRight(2.5.vw)
        }

        val marginSmall by style {
            margin(8.px)
        }

        val marginMedium by style {
            margin(16.px)
        }

        val rowCentered by style {
            display(DisplayStyle.Flex)
            flexFlow(FlexDirection.Row, FlexWrap.Nowrap)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            width(100.percent)
        }

        val column by style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            justifyContent(JustifyContent.Start)
            alignItems(AlignItems.Center)
        }

        val flexboxContainer by style {
            display(DisplayStyle.Flex)
            flexFlow(FlexDirection.Row, FlexWrap.Wrap)
            justifyContent(JustifyContent.SpaceBetween)
            alignItems(AlignItems.Center)
        }

        val flexboxItem by style {
            flex(1,1, 0.px)
        }

        val teamName by style {
            fontSize(1.em)
            margin(0.px)
            textAlign("center")
        }

        val iconContainer by style {
            media(mediaMaxWidth(768.px)) {
                self style {
                    marginRight(15.vw)
                    marginLeft(15.vw)
                    marginTop(16.px)
                    textAlign("center")
                }
            }
            media(mediaMinWidth(768.plus(1).px)) {
                self style {
                    marginRight(32.px)
                    marginLeft(32.px)
                    marginTop(16.px)
                    textAlign("center")
                }
            }
        }

        @OptIn(ExperimentalComposeWebApi::class)
        val fillableIcon by style {
            if (darkMode) {
                filter {
                    invert(98.percent)
                    sepia(0.percent)
                    saturate(0.percent)
                    hueRotate(218.deg)
                    brightness(107.percent)
                    contrast(102.percent)
                }
            } else {
                filter {
                    invert(0.percent)
                    sepia(0.percent)
                    saturate(7500.percent)
                    hueRotate(297.deg)
                    brightness(96.percent)
                    contrast(104.percent)
                }
            }
            height(48.px)
        }

        val logo by style {
            height(48.px)
        }

        val scheduleTeamLogoContainer by style {
            width(100.percent)
        }

        val scheduleTeamLogo by style {
            media(mediaMaxWidth(768.px)) {
                self style {
                    minHeight(50.px)
                    height(10.vw)
                    maxHeight(7.5.vh)
                }
            }
            media(mediaMinWidth(768.plus(1).px)) {
                self style {
                    minHeight(50.px)
                    height(10.vw)
                    maxHeight(10.vh)
                }
            }
        }

        val scheduleSponsorImage by style {
            media(mediaMinWidth(800.px)) {
                self style {
                    maxWidth(800.px)
                    maxHeight(100.px)
                }
            }
            media(mediaMaxWidth(800.minus(1).px)) {
                self style {
                    maxWidth(100.percent)
                    maxHeight(100.px)
                }
            }
        }

        val gameComponent by style {
            media(mediaMinWidth(768.px)) {
                self style {
                    minWidth(768.px)
                    flexGrow(3)
                }
            }
            media(mediaMaxWidth(768.minus(1).px)) {
                self style {
                    minWidth(100.vw)
                }
            }
        }
    }
}